
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface ComparisonNavbarProps {
  scrolled: boolean;
}

export default function ComparisonNavbar({ scrolled }: ComparisonNavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || mobileMenuOpen ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-black/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/15c46b4804cbc70ab5f2207b2f29e22b.png"
              alt="NeuroAgents Global AI"
              className="h-8 sm:h-10 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-white/80 hover:text-white uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              INÍCIO
            </Link>
            <Link
              to="/casos-de-sucesso"
              className="text-white/80 hover:text-white uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              CASOS DE SUCESSO
            </Link>
            <Link
              to="/blog"
              className="text-white/80 hover:text-white uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              BLOG
            </Link>
            <a
              href="https://wa.me/5541992584018"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary hover:bg-primary-dark text-white px-5 py-2.5 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              FALAR COM CONSULTOR
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            mobileMenuOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="flex flex-col space-y-1 pb-4">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="text-white/80 hover:text-white hover:bg-white/10 uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              INÍCIO
            </Link>
            <Link
              to="/casos-de-sucesso"
              onClick={() => setMobileMenuOpen(false)}
              className="text-white/80 hover:text-white hover:bg-white/10 uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              CASOS DE SUCESSO
            </Link>
            <Link
              to="/blog"
              onClick={() => setMobileMenuOpen(false)}
              className="text-white/80 hover:text-white hover:bg-white/10 uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              BLOG
            </Link>
            <a
              href="https://wa.me/5541992584018"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary hover:bg-primary-dark text-white uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-center mt-2"
            >
              FALAR COM CONSULTOR
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
